import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";
import TableLoader from "components/common/TableLoader/TableLoader";
import CreateUser from "../CreateUser/CreateUser";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { AppContext } from "AppProvider/AppContext";
import { HiOutlineRefresh } from "react-icons/hi";

export default function UserTable() {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [editData, setEditData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const { toastNotify } = useContext(AppContext);
  const getUsers = async () => {
    // const request = {
    //   search
    // };
    try {
      setLoading(true);
      const response: any = await appRequest("user", "getAllAdmins", {});
      setUsersData(response?.users);
      console.log("get getAllAdmins response", response.users);
    } catch (error: any) {
      console.error("error in getting users data", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item: any) => {
    setEditData(item);
    setIsCreateModalOpen(true);
  };

  console.log("deleteId", deleteId);

  // console.log('editData',editData)

  useEffect(() => {
    //   const response: any =appRequest("user", "getPermissions", {userId:"66fb9b9380917aac1c3fc49f"});
    getUsers();
  }, []);

  const handleSubmitEditedData = async (data: any) => {
    const editData = {
      userId: data._id,
      name: data?.name,
      username: data?.username,
      moNumber: data?.moNumber,
      permission: data?.permission,
      role: data.role,
    };
    console.log("update api request", editData)
    try {
      const response: any = await appRequest("user", "updateAdmin", editData);
      if (response.status === "success") {
        toastNotify({
          title: "Success",
          message: "User updated successfully",
          type: "success",
        });
        getUsers();
        setIsCreateModalOpen(false);
      } else {
        toastNotify({
          titel: "Error",
          message: "Error in updating user data",
          type: "error",
        });
      }
    } catch (error: any) {
      console.error("error in updating the user", error.message);
    }
  };

  const handleDelete = async () => {
    try {
      const response: any = await appRequest("user", "delete", {
        id: deleteId,
      });
      console.log("response", response);
      if (response.status === "success") {
        toastNotify({
          title: "Success",
          message: "User Deleted successfully",
          type: "success",
        });
        getUsers();
        setOpenModal(false);
      } else {
        toastNotify({
          title: "Error",
          message: "Error in deleting user",
          type: "error",
        });
      }
    } catch (error) {
      console.error("error in deleting the user", error);
    }
  };

  return (
    <Box
      p={5}
      rounded={"lg"}
      bg={"white"}
      shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
    >
      <Flex justifyContent={"space-between"} mb={2}>
        <Text fontWeight={700} fontSize={"xl"} color={"teal.400"}>
          Users
        </Text>
        <Flex gap={4}>
          <Button
            onClick={() => {
              setEditData({});
              setIsCreateModalOpen(true);
            }}
            colorScheme="teal"
          >
            Create
          </Button>
          <Tooltip label="Refresh" hasArrow>
            <IconButton
              aria-label="Refresh"
              icon={<HiOutlineRefresh />}
              colorScheme="teal"
              variant="outline"
              borderWidth={2}
              _hover={{ bg: "teal.100" }}
              onClick={getUsers}
              size={{ base: "sm", md: "md" }}
            />
          </Tooltip>
        </Flex>
      </Flex>
      <TableContainer>
        <Table variant="striped" size={"sm"}>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Mobile</Th>
              <Th></Th>
              {/* <Th></Th> */}
            </Tr>
          </Thead>
          <TableLoader loader={loading} show={usersData?.length}>
            <Tbody>
              {usersData?.map((item: any, index: number) => (
                <Tr key={index}>
                  <Td>{item?.name}</Td>
                  <Td>{item?.username}</Td>
                  <Td>{item?.moNumber}</Td>
                  <Td display={"flex"} gap={6}>
                    <IconButton
                      size={"sm"}
                      colorScheme="teal"
                      variant={"outline"}
                      aria-label="Edit"
                      icon={<EditIcon />}
                      onClick={() => handleEdit(item)}
                    />
                    <IconButton
                      size={"sm"}
                      colorScheme="red"
                      variant={"outline"}
                      aria-label="Delete"
                      icon={<DeleteIcon />}
                      onClick={() => {
                        setOpenModal(true);
                        setDeleteId(item?._id);
                      }}
                    // onClick={() => handleDelete(item.id)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </TableLoader>
        </Table>
      </TableContainer>
      <CommonModal
        header="Create User"
        width={"60vw"}
        // size={"3xl"}
        animate={true}
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        body={
          <Box>
            <CreateUser
              getUsers={getUsers}
              onSubmit={handleSubmitEditedData}
              initialData={editData}
              setIsCreateModalOpen={setIsCreateModalOpen}
            />
          </Box>
        }
      />

      <CommonModal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        isCentered={true}
        size="md"
        closeOnOverlayClick={false}
        body={
          <Box p={{ base: 0, md: 4 }} mt={{ base: 2, md: 0 }}>
            <Text
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              mb={{ base: 2, md: 4 }}
            >
              Confirm ?
            </Text>
            <Text fontSize="md" textAlign="center" color="gray.600">
              Are you sure you want to delete this user ?
            </Text>
          </Box>
        }
        footer={
          <Flex
            justify="center"
            gap={{ base: 2, md: 4 }}
            w={"full"}
            borderColor="gray.200"
          >
            <Button
              onClick={() => {
                setOpenModal(false);
              }}
              colorScheme="red"
              size={{ base: "sm", md: "md" }}
              variant="outline"
              _hover={{ bg: "red.100" }}
            >
              No, Keep User
            </Button>
            <Button
              onClick={() => handleDelete()}
              colorScheme="teal"
              size={{ base: "sm", md: "md" }}
              _hover={{ bg: "teal.400" }}
              isLoading={loading}
            >
              Yes, Delete User
            </Button>
          </Flex>
        }
      />
    </Box>
  );
}
